// extracted by mini-css-extract-plugin
module.exports = {"sin_fondo":"Cloud__sin_fondo__1K5ws","fondo_azul":"Cloud__fondo_azul__1_paP"};